import { appSettingsService } from './AppSettingsService';
import { appServiceConfig } from './config/appServiceConfig';

/**
 * Initializes the application by loading configuration settings
 * This should be called early in the application lifecycle
 */
export async function initializeApp(): Promise<void> {
  try {
    // Load app settings
    await appSettingsService.loadSettings();

    // Initialize service configuration
    await appServiceConfig.initialize();
  } catch (error) {
    // Don't throw - let the app continue with defaults
  }
}

/**
 * Gets the application settings after initialization
 * @returns Promise<AppSettings> - The current app settings
 */
export async function getAppSettings() {
  return await appSettingsService.getSettings();
}

/**
 * Gets a specific setting value
 * @param path - Dot notation path to the setting
 * @returns Promise<any> - The setting value
 */
export async function getAppSetting<T = any>(path: string): Promise<T> {
  return await appSettingsService.getSetting<T>(path);
}